export const gtagReportConversion = (url) => {
  if (import.meta.server) return false;

  const gtag = useGtag();

  if (!gtag?.gtag) {
    console.warn("gtag is not initialized yet");
    return false;
  }

  const config = useRuntimeConfig();

  gtag.gtag("event", "conversion", {
    send_to: config.public.gtagConversionSendTo,
    value: 1.0,
    currency: "IDR",
    event_callback: () => {
      if (url) window.location = url;
    },
  });

  return false;
};
